import { checkoutSession as checkoutSessionUrls } from "@circle-react/helpers/urlHelpers/internalApi/paywalls/checkout/sessions";
import { useQuery } from "react-query";
import type { UseQueryResult } from "react-query";

import type { ApiError } from "@/react/config/CustomErrors";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import type {
  CheckoutSession,
  PaymentValidationParams,
} from "@/react/types/Paywalls/Checkout/Session";

import { getCheckoutSessionQueryKey } from "../../helpers/sessions/getCheckoutSessionQueryKey";

interface FetchCheckoutSessionParams {
  paymentValidationParams?: PaymentValidationParams;
  paywallId: number | null;
  sessionId?: number | null;
  stepId?: number | null;
}

export const useFetchCheckoutSession = (
  params: FetchCheckoutSessionParams,
): UseQueryResult<CheckoutSession, ApiError> => {
  const { paywallId, sessionId, stepId, paymentValidationParams } = params;

  return useQuery({
    queryKey: getCheckoutSessionQueryKey(paywallId ?? 0),
    queryFn: async () => {
      if (!paywallId) {
        throw new Error("paywallId is required");
      }

      const url = checkoutSessionUrls.show({
        paywallId,
        sessionId: sessionId || undefined,
        stepId: stepId || undefined,
        paymentIntentId: paymentValidationParams?.paymentIntentId,
        invoiceId: paymentValidationParams?.invoiceId,
        setupIntentId: paymentValidationParams?.setupIntentId,
      });
      return reactQueryGet<CheckoutSession>(url);
    },
    enabled: !!paywallId && (!!sessionId || !!stepId),
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
  });
};
